import {
  Scene,
  HemisphereLight,
} from 'three'

import { component } from '../bidello'
import world from './world/world'
// import smoke from './smoke/smoke'
// import inspire from './inspire/inspire'

class Stage extends component(Scene) {
  init() {
    this.hemiLight = new HemisphereLight(0xffffff, 0xffffff)
    this.hemiLight.position.set(0, 0, 0)
    this.add(this.hemiLight)
  }

  onLoadEnd() {
    this.add(world)
    // this.add(inspire)
    // this.add(smoke)
  }
}

export default new Stage()
